import { inject, Injectable, signal } from '@angular/core';
import { AuthStateService } from './auth-state.service';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  // observable para suscribirse
  authReady = inject(AuthStateService).authReady;

  // Panel header
  panel_header_title = signal('');
  panel_header_subtitle = signal('');
  panel_header_showBackButton = signal(false);
  panel_header_icon = signal<string | null>(null);

  setPanelHeader({
    title,
    subtitle = '',
    showBackButton = false,
    icon = null,
  }: {
    title: string;
    subtitle?: string;
    showBackButton?: boolean;
    icon?: string | null;
  }) {
    this.panel_header_title.set(title);
    this.panel_header_subtitle.set(subtitle);
    this.panel_header_showBackButton.set(showBackButton);
    this.panel_header_icon.set(icon);
  }
  restartPanelHeader() {
    this.setPanelHeader({ title: '', subtitle: '', showBackButton: false, icon: null });
  }
}
